export enum NetworkState {
  idle = 'idle',
  loading = 'loading',
  done = 'done',
}
